import { render, staticRenderFns } from "./magnifier.vue?vue&type=template&id=75670f29&scoped=true"
import script from "./magnifier.vue?vue&type=script&lang=js"
export * from "./magnifier.vue?vue&type=script&lang=js"
import style0 from "./magnifier.vue?vue&type=style&index=0&id=75670f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75670f29",
  null
  
)

export default component.exports